import React from "react";
import { Phone, Mail } from "lucide-react";
import "./footer.css";
export default function Footer() {
	return (
		<footer>
			<img
				src="/images/footer.avif"
				alt="Heron Logo"
				className="footer-image"
			/>
			<div className="footer">
				<div className="footer-left">
					<div className="footer-contact-info">
						<div>
							{/* <div className="footer-contact-info-item">
                                <Phone size={24} className="footer-icon green" />
                                <div className="footer-contact-info phone">360-927-7748</div>
                            </div>
                            <div className="footer-contact-info-item">
                                <Mail size={24} className="footer-icon green" />
                                <div className="footer-contact-info email">graceinsumas@gmail.com</div>
                            </div> */}
							<div className="footer-contact-info-item">
								<Mail size={24} className="footer-icon green" />
								<a
									href="mailto:graceinsumas@gmail.com"
									className="footer-contact-info email"
								>
									graceinsumas@gmail.com
								</a>
							</div>
							<div className="footer-contact-info-item">
								<Phone size={24} className="footer-icon green" />
								<a href="tel:3609277748" className="footer-contact-info phone">
									360-927-7748
								</a>
							</div>
						</div>
					</div>
					<p className="desktop-copyright">
						&copy; 2026{" "}
						<a href="http://harborviewwebdesign.com" className="copyright-link">
							Harborview Web Design
						</a>
						. All rights reserved.
					</p>
				</div>
				<img
					src="/images/heronlogowhite.avif"
					alt="Heron Logo"
					className="footer-logo"
				/>
				<p className="mobile-copyright">
					&copy; 2026{" "}
					<a href="http://harborviewwebdesign.com" className="copyright-link">
						Harborview Web Design
					</a>
					. All rights reserved.
				</p>
			</div>
		</footer>
	);
}
